import React from "react";

interface PreviewImageProps {
  image: string;
}

export default function PreviewImage({ image }: PreviewImageProps) {
  return (
    <div className="thumb">
      <img id="image-preview" src={image} alt="" style={{overflow: "hidden", maxWidth: "24vw"}} />
    </div>
  );
}
